import axios from 'axios'
import { host } from '../../../helper/config'
import { getItemPerPage } from '../../../helper/helper'

const PLUGINS_NAME = 'admin-classic-statistic'

export const getStatistic = async (token, query, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-list`, {
        ...query,
        page: page,
        itemPerPage: getItemPerPage()
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const exportAllStatistic = async (token, query) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/export-all`, {
        ...query
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })
    
    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const getStatisticSummary = async (token, query) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-summary`, {
        ...query
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}
